import { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CodeVerif from "../Profile/EmailConfirm/CodeVerif";
import axios from "axios";
import { domain } from "../Links/Links";
import { baseWebsocket } from "./BaseWebsocket";
import { currentUserWebSocket } from "./CurrentUserWebSocket";
import EmailConfirm from "../Profile/EmailConfirm/EmailConfirm";

export const AuthContext = createContext();

function SessionChecker({ children, theme }) {
  const [sessionStatus, setSessionStatus] = useState(null);
  const [currentUserUsername, setCurrentUserUsername] = useState("");
  const [currentUserFullname, setCurrentUserFullname] = useState("");
  const [currentUserEmail, setCurrentUserEmail] = useState(null);

  const [authenticationStatus, setAuthenticationStatus] = useState(false);
  const [authenticationImage, setAuthenticationImage] = useState(false);

  const [tick, setTick] = useState(false);

  // email
  const [emailConfirmStatus, setEmailConfirmStatus] = useState(false);
  const [codeVerifStatus, setCodeVerifStatus] = useState(false);

  const [emailStatus, setEmailStatus] = useState(false);

  const [tomanLicence, setTomanLicence] = useState(false);

  const { t } = useTranslation();

  const [recentSearchData, setRecentSearchData] = useState([]);

  const [productsDataInExplorer, setProductsDataInExplorer] = useState([]); 

  const [currentUserAddress, setCurrentUserAddress] = useState('');
  const [currentUserPhoneNumber, setCurrentUserPhoneNumber] = useState('');

  useEffect(() => {
    const request = async () => {

      const response = await axios.get(domain + "/session_check/", {
        withCredentials: true,
      });

      console.log(response.data)

      if (response.data.session_status == true) {
        setSessionStatus(true);
        setCurrentUserUsername(response.data.current_user_username);
        setCurrentUserFullname(response.data.current_user_fullname);
      } else {
        setSessionStatus(false);
      }

      if (response.data.tick == true) {
        setTick(true);
      }

      if (response.data.authentication_status == true) {
        setAuthenticationStatus(true);
      }

      if (response.data.authentication_image == true) {
        setAuthenticationImage(true);
      }

      if (response.data.current_user_email) {
        setCurrentUserEmail(response.data.current_user_email);
      }

      if (response.data.email_confirm == true) {
        setEmailStatus(true);
      }

      if (response.data.toman_licence == true) {
        setTomanLicence(true);
      } 

      if (response.data.address != null) {
        setCurrentUserAddress(response.data.address)
      } 

      if (response.data.phone_number != null) {
        setCurrentUserPhoneNumber(response.data.phone_number)
      } 

    };


    request();

    
  }, []);

  useEffect(() => {
      if (!currentUserUsername) return;

      const currentUserSocket = currentUserWebSocket(currentUserUsername , setRecentSearchData)
      const baseSocket = baseWebsocket(setProductsDataInExplorer)
      return () => {
        currentUserSocket.close();
        baseSocket.close();
      }

  }, [currentUserUsername])

  if (sessionStatus == null) {
    return (
      <div className="loadingDiv">
        {theme === "light" ? (
          <img src="/icons/hiket.png" className=""></img>
        ) : (
          <img src="/icons/hiket2.png" className=""></img>
        )}
      </div>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        sessionStatus,
        setSessionStatus,
        currentUserUsername,
        currentUserFullname,
        currentUserEmail,
        setCurrentUserEmail,
        setCurrentUserUsername,
        setCurrentUserFullname,

        authenticationStatus,
        authenticationImage,
        setAuthenticationImage,

        emailConfirmStatus,
        setEmailConfirmStatus,

        codeVerifStatus,
        setCodeVerifStatus,

        emailStatus,
        setEmailStatus,

        tomanLicence,

        tick,

        recentSearchData,
        setRecentSearchData,

        productsDataInExplorer,
        setProductsDataInExplorer,

        currentUserAddress,
        currentUserPhoneNumber,
      }}
    >
      {children}

      {/* email */}
      {emailConfirmStatus && <EmailConfirm theme={theme}></EmailConfirm>}  

      {codeVerifStatus && <CodeVerif theme={theme}></CodeVerif>}
    </AuthContext.Provider>
  );
}

export default SessionChecker;
